import setAlign from './setAlign';

/**
 * Set align self attribute to node's Yoga instance
 *
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */
const setAlignSelf = setAlign('self');

export default setAlignSelf;
